/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PhoneNumbers.scss';

import React from 'react';

const PhoneNumberHeader = ({ addressType }) => {
  let columnTwoHeader, columnThreeHeader, columnTwoClassname;

  if (addressType === 'non-us') {
    columnTwoHeader = 'Country Code';
    columnThreeHeader = 'Number';
    columnTwoClassname = 'phone-number-country-code';
  } else {
    columnTwoHeader = 'Number';
    columnThreeHeader = 'Ext';
    columnTwoClassname = 'phone-number-number';
  }

  return (
    <div className="phone-number-row heading-row">
      <div className="phone-number-phone">
        <div className="header header-phone">Phone</div>
      </div>
      <div className="phone-number-number-wrapper">
        <div className={columnTwoClassname}>
          <div className="header header-number">{columnTwoHeader}</div>
        </div>
        <div className="phone-number-ext">
          <div className="header header-ext">{columnThreeHeader}</div>
        </div>
      </div>
    </div>
  );
};

export default PhoneNumberHeader;
